export const classes = {
  title: 'font-bold text-xl text-grey-8 inline',
  subtitle: 'font-normal text-sm text-grey-7 inline',
  closeButtonWrapper: 'py-6 flex justify-between items-start',
  closeButtonTitles: 'flex flex-col',
  closeButton: 'text-grey-5',
  titles: 'py-6',
};
